module.exports = __webpack_public_path__ + "img/Retail-Mug.dfb117fe.jpg";